import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { ActivityScreen } from "../../screens/act/index.ts";

/** `/activity`: what happened in the company and what Adea did for it in the last 30 days. */
export const Route = createFileRoute("/_app/activity")({
  loader: ({ context }) => context.queryClient.prefetchQuery(actions.queryOptions("activity.list", {})),
  component: ActivityScreen,
});
